import React from "react";
import GlobalStyles from "../components/GlobalStyles";
import GlobalFonts from "../components/GlobalFonts";
import { LandingWrapper } from "../styles/components/Global/Global";
import Loader from "../components/Loader";
import Landing from "../components/Landing";

const IndexPage = () => {
  return (
    <LandingWrapper>
      <GlobalStyles />
      <GlobalFonts />
      <Loader />
      <Landing />
    </LandingWrapper>
  );
};

export default IndexPage;
